import { canNavigate } from '@/plugins/casl/canNavigate'
import { useAuthStore } from '@/stores/auth'
import { useLocalStorage } from '@vueuse/core'

export const setupGuards = router => {
  router.beforeEach(async to => {
    if (to.meta.public)
      return

    const isLoggedIn = !!(useCookie('userData').value && useCookie('accessToken').value)

    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn)
        return '/'
      else
        return undefined
    }

    // Modul C (addendum 04 §3): edge case — accessToken masih valid tapi
    // ability (localStorage, lihat auth.js) kosong/hilang (mis. ke-clear
    // manual, race saat login). Refresh sekali dari backend dulu sebelum
    // canNavigate, supaya user yang sebenarnya berhak tidak salah ke-block
    // gara-gara ability kosong.
    if (isLoggedIn && !useLocalStorage('userAbilityRules', []).value?.length)
      await useAuthStore().fetchUser()

    if (!canNavigate(to) && to.matched.length) {
      return isLoggedIn
        ? { name: 'not-authorized' }
        : {
            name: 'login',
            query: {
              ...to.query,
              to: to.fullPath !== '/' ? to.path : undefined,
            },
          }
    }
  })
}
